import { render, staticRenderFns } from "./RiskAssessmentRegular.vue?vue&type=template&id=3b7f5eba&scoped=true&"
import script from "./RiskAssessmentRegular.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f5eba",
  null
  
)

export default component.exports